import { formatReportDateUnix } from "@entities/history";
import { LEGAL_WARNINGS } from "./constants";
import { ReportLegalProps } from "./types";
import classes from "./report-legal.module.scss";

export const ReportLegal = ({ pledge, registration, stealing }: ReportLegalProps) => {
    return (
        <div className={classes.legal}>
            <div className={classes.legal__item}>
                <div className={classes.legal__title}>
                    {pledge.status === "ok" ? pledge.text : LEGAL_WARNINGS.PLEDGE}
                </div>
                <div>{formatReportDateUnix(pledge.requestTime)}</div>
                <div>По данным Реестра уведомлений о залоге движимого имущества</div>
            </div>

            <div className={classes.legal__item}>
                <div className={classes.legal__title}>
                    {registration.status === "ok" ? registration.text : LEGAL_WARNINGS.REGISTRATION}
                </div>
                <div>{formatReportDateUnix(registration.requestTime)}</div>
                <div>По данным ГИБДД</div>
            </div>

            <div className={classes.legal__item}>
                <div className={classes.legal__title}>
                    {stealing.status === "ok" ? stealing.text : LEGAL_WARNINGS.STEALING}
                </div>
                <div>{formatReportDateUnix(stealing.requestTime)}</div>
                <div>По данным ГИБДД</div>
            </div>
        </div>
    );
};